import { RGBA } from '@ctrl/tinycolor'

export const parseToObject = (stringColor: string): RGBA => {
  const rgbaArray = stringColor.split('(')[1].split(')')[0].split(',')

  return {
    r: +rgbaArray[0],
    g: +rgbaArray[1],
    b: +rgbaArray[2],
    a: +rgbaArray[3],
  }
}

export const getColorAsString = (color: RGBA) =>
  `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`

export const isRgba = (style: string) => /^rgba/.test(style)
export const isHexColor = (color: string): boolean => {
  // #FFF (short), #FFFFFF (long), #FFFFFFFF (w/ alpha layer)
  const hexColorRegex = /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/
  return hexColorRegex.test(color)
}

export const changeStringColorOpacity = (
  stringColor: string,
  opacity: number,
) => {
  const colorObj = parseToObject(stringColor)
  colorObj.a = opacity
  return getColorAsString(colorObj)
}

export function isNotTransparent(color: string) {
  const { a } = parseToObject(color)

  return Boolean(a)
}

export function isTransparent(color: string) {
  const { a } = parseToObject(color)

  return !a
}

export function RGBAToHexA(rgba: string) {
  const obj = parseToObject(rgba)
  let r = obj.r.toString(16)
  let g = obj.g.toString(16)
  let b = obj.b.toString(16)
  // let a = Math.round(obj.a * 255).toString(16)

  if (r.length === 1) r = `0${r}`
  if (g.length === 1) g = `0${g}`
  if (b.length === 1) b = `0${b}`
  // if (a.length === 1) a = '0' + a

  // return '#' + r + g + b + a
  return `#${r}${g}${b}`
}

export const hexToRgba = (hex: string): string => {
  // Remove the leading '#' if present
  let clearHex = hex.replace(/^#/, '')

  // Handle 3-character hex (e.g., #FFF)
  if (clearHex.length === 3) {
    clearHex = clearHex
      .split('')
      .map(char => char + char)
      .join('')
  }

  // Extract RGB and Alpha values
  const r = Number.parseInt(hex.substring(0, 2), 16)
  const g = Number.parseInt(hex.substring(2, 4), 16)
  const b = Number.parseInt(hex.substring(4, 6), 16)
  const a =
    hex.length === 8 ? Number.parseInt(hex.substring(6, 8), 16) / 255 : 1

  // Return the RGBA string
  return `rgba(${r}, ${g}, ${b}, ${a})`
}

export const addOpacityToRGBA = (rgba: string, opacity: number) => {
  const rgbaRegex =
    /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*(\d?\.?\d+))?\s*\)$/

  if (!rgbaRegex.test(rgba)) {
    // biome-ignore lint/suspicious/noConsole: @TODO should be reported but no rollbar instance available
    console.error('Invalid RGBA format')
    return rgba
  }

  return rgba.replace(rgbaRegex, `rgba($1, $2, $3, ${opacity})`)
}
